import { useEffect, useRef, useState } from "react";
import { Drawer, DrawerRef } from "../../../../components/drawers/Drawer";
import Indicator from "../../../../components/base/Indicator";
import { SortTypes } from "../../../../core/Enums";
import { useHub } from "../../../../core/Global";
import { JobsReportRequest } from "../models/JobsReportRequest";
import { JobsColumnsVisibility } from "../models/JobReportModel";
import Job from "../../../crm/jobs/models/Job";
import JobsReportTables from "./JobsReportTables";


// Mobile: opens the drilled segment's jobs (the "second table") inside a closable drawer
// (big on desktop / full-screen on mobile) instead of replacing the whole report. Reuses
// JobsReportTables with only `jobs` so it renders exactly the desktop jobs table.
interface IProps {
    body: JobsReportRequest
    item: { title: string; value: string; avatar?: string }
    filterQuery?: string
    jobsColsVisibility?: JobsColumnsVisibility
    onClose: () => void
}

export default function JobsReportDrillDrawer(props: IProps) {

    const hub = useHub();
    const drawerRef = useRef<DrawerRef>(null);

    const [jobs, jobsSet] = useState<Job[]>();
    const [loading, loadingSet] = useState<boolean>(true);

    const drillBody: JobsReportRequest = { ...props.body, segmentIds: [props.item.value] };

    useEffect(() => {
        let q = "?a=1";
        if (props.filterQuery) q += "&" + props.filterQuery;
        hub.Post("/reports/jobs/chart/" + q, {
            ...drillBody,
            sortKey: "",
            sortType: SortTypes.Descending
        }, res => {
            if (res.success) {
                jobsSet(res.data.jobs);
                loadingSet(false);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Drawer ref={drawerRef} id="drawer-jobs-report-drill" title={props.item.title} subtitle="Jobs"
            size="xlarge" onClose={props.onClose}>
            <div className="p-2">
                {
                    loading ?
                        <div className="py-20 text-center"><Indicator /></div>
                        :
                        <JobsReportTables body={drillBody} jobs={jobs}
                            jobsColsVisibility={props.jobsColsVisibility} onRefetch={() => { }} />
                }
            </div>
        </Drawer>
    );
}
